/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneShowsSlider from 'sites/allas/components/standalone/ShowsSlider';

export const DynamicStandaloneShowsSlider = StandaloneShowsSlider;
export type DynamicStandaloneShowsSliderProps = PropsFromComponent<typeof StandaloneShowsSlider>;

export const DynamicStandaloneShowsSliderWith = (extras: DynamicStandaloneExtras): typeof StandaloneShowsSlider => {
    return function DynamicStandaloneShowsSlider(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'ShowsSlider');
        return <StandaloneShowsSlider {...mergeProps({ options: { theme } }, props)} />;
    }
}